// Modules
import React from 'react';
import { inject, observer } from 'mobx-react';


// MATERIAL UI
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import red from 'material-ui/colors/red';
import blue from 'material-ui/colors/blue';

// Styles
import './style.css';

const errorColor = red[500];
const notificationColor = blue[500];

@inject('AuthStore')
@observer
export default class extends React.Component {
  handleKeyDown = (key) => {
    if (key.keyCode === 13) {
      this.props.AuthStore.signInWithEmailAndPassword();
    }
  }
  render() {
    const {
      AuthStore,
    } = this.props;
    return (
      <div>
        <AppBar position="static">
          <Toolbar>
            <Typography type="title" color="inherit">
              {'Login'}
            </Typography>
          </Toolbar>
        </AppBar>
        <div className="logo-container">
          <img src="./img/png/Logo.png" alt="Aspect Engineering Logo" />
        </div>
        <div className="login-input-container">
          <TextField
            className="input"
            label="Email"
            type="email"
            value={AuthStore.email}
            onChange={(e) => { AuthStore.email = e.target.value; }}
            onKeyDown={this.handleKeyDown}
            margin="normal"
          />
          <TextField
            className="input"
            label="Password"
            type="password"
            value={AuthStore.password}
            onChange={(e) => { AuthStore.password = e.target.value; }}
            onKeyDown={this.handleKeyDown}
            margin="normal"
          />
        </div>
        <div className="login-message-container">
          <span className="error-message" style={{ color: errorColor }}>{AuthStore.errorMessage}</span>
          <span className="notification-message" style={{ color: notificationColor }}>{AuthStore.notifyMessage}</span>
        </div>
        <div className="login-button-container">
          <Button
            raised
            color="primary"
            fullWidth
            onClick={() => AuthStore.signInWithEmailAndPassword()}
          >
            Login
          </Button>
        </div>
        <div className="login-button-container">
          <Button
            onClick={() => AuthStore.sendPasswordResetEmail()}
          >
            Forgot Pasword
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/index.js